module.exports = __webpack_public_path__ + "static/media/logo.ffc86a1c.png";